import { render, staticRenderFns } from "./driedLeaf.vue?vue&type=template&id=5c5e038c&scoped=true&"
import script from "./driedLeaf.vue?vue&type=script&lang=js&"
export * from "./driedLeaf.vue?vue&type=script&lang=js&"
import style0 from "./driedLeaf.vue?vue&type=style&index=0&id=5c5e038c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5e038c",
  null
  
)

export default component.exports